import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface IMaintenancePageConfig {
  show: boolean;
  subtext?: string;
  start_time?: string;
  end_time?: string;
}

export interface IBannerConfig {
  show: boolean;
  need_login?: boolean;
  applied_for?: {
    all: boolean;
    marketplace: boolean;
    workcover: boolean;
  };
  messages?: string[];
  message_head?: string;
  start_time?: string;
  end_time?: string;
}
export interface IMaintenanceConfig {
  maintenance: IMaintenancePageConfig;
  banner: IBannerConfig;
  repeat: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {
  public constructor(private readonly http: HttpClient) {}

  public getMaintenanceConfig(): Observable<IMaintenanceConfig> {
    const url = `assets/maintenance.json?ts=${Date.now()}`;
    return this.http
      .get<IMaintenanceConfig>(url)
      .pipe(catchError(() => of({ maintenance: { show: false }, banner: { show: false }, repeat: false })));
  }
}
